import React, { useEffect } from 'react';
import './EndtoEnd.css';

const EndtoEnd = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "PCB Visual Inspection Process",
            description: "Inspecting PCBs to ensure quality and reliability in IoT device assembly."
        },
        {
            title: "Card Level Testing Process",
            description: "Testing individual circuit cards to verify functionality and performance."
        },
        {
            title: "Code Loading Process",
            description: "Loading firmware and software onto IoT devices for operational readiness."
        },
        {
            title: "Configuration Process",
            description: "Configuring device settings to meet specific IoT application requirements."
        },
        {
            title: "Calibration Process",
            description: "Calibrating sensors and components for accurate performance in embedded systems."
        },
        {
            title: "Functional Testing Process",
            description: "Conducting functional tests to ensure IoT devices operate as intended."
        },
        {
            title: "Final Test Process",
            description: "Performing comprehensive final tests to validate overall device performance."
        },
        {
            title: "Enclosure Fixing Process",
            description: "Assembling protective enclosures to safeguard IoT device components."
        },
        {
            title: "Cabling Process",
            description: "Installing and securing cabling for reliable connectivity in IoT systems."
        },
        {
            title: "Screw Fixing Process",
            description: "Securing components with precise screw fixing for structural integrity."
        },
        {
            title: "Quality Testing Process",
            description: "Conducting quality tests to ensure IoT devices meet industry standards."
        },
        {
            title: "Final Packing Process",
            description: "Packaging IoT devices for safe transport and delivery."
        },
        {
            title: "Dispatch Process",
            description: "Managing logistics to dispatch IoT devices to customers or distributors."
        }
    ];

    return (
        <div className="detail-page1">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                End-to-End Product Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our end-to-end product development services deliver comprehensive solutions for IoT and embedded systems, from PCB assembly to dispatch, ensuring quality and performance.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EndtoEnd;